import { LoginCallback as OktaLoginCallback } from '@okta/okta-react';
import { Link } from 'react-router-dom';

const CustomCallbackError = ({ error }: { error: Error }) => {
  return (
   <div className="mt-4 flex flex-col items-center gap-4">
      <p className="text-red-500 font-medium max-w-md">
        {error.toString()}
      </p>
     
      <Link to="/" className="px-4 py-2 bg-primary text-primary-foreground hover:bg-primary/90 rounded-md text-sm font-medium transition-colors shadow-sm">
        Return Home
      </Link> 
      
    </div>
  );
};

export const LoginCallback = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Completing sign in...</p>
        <OktaLoginCallback 
          loadingElement={<></>} 
          errorComponent={CustomCallbackError} 
        />
      </div>
    </div>
  );
};
